import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmQrScannerOverlayComponent} from './sm-qr-scanner-overlay.component';
import {SmActionButtonModule} from '../sm-action-button/sm-action-button.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SmActionButtonModule,
  ],
  declarations: [SmQrScannerOverlayComponent],
  exports: [SmQrScannerOverlayComponent],
})
export class SmQrScannerOverlayModule {}
